<!--
 * @Descripttion: 修改了一些内容
 * @version: v1.0
 * @Author: htt
 * @Date: 2021-12-30 16:32:45
 * @LastEditors: htt
 * @LastEditTime: 2021-12-31 11:28:00
-->
<template>
    <div>
        <el-col :span="6" v-for="item in list" :key="item.id">
            <!-- :class="{'is-danger':type.type=='1','is-warning':type.type=='2','is-default':type.type=='3'}" -->
            <el-card class="projectCard" :body-style="{background:type.type==3?'rgba('+rgbaFn(type.color)+',0.1)':''}" >
                <div slot="header" class="clearfix" :style="{background:'rgba('+rgbaFn(type.color)+',0.2)',padding:'9px'}"  v-if="item.bidSectionCode">
                    <img :src="type.imgUrl" alt="">
                    <span class="card_title">{{item.bidSectionCode}}</span>
                    <div class="header_img">
                        <img src="~@/assets/images/fixed.png" v-if="item.historyid==-1" alt="">
                        <img src="~@/assets/images/status_processed.png" v-if="item.historyid==0" alt="">
                        <img src="~@/assets/images/status_ignore.png" v-if="item.historyid==1" alt="">
                    </div>
                    <div class="header_img1">
                        <img src="~@/assets/images/status_bg.png" alt="">
                    </div>
                </div>
                <div class="text item">
                    <div class="card_text">
                            <el-tooltip effect="dark" :content="item.bidSectionName" placement="right">
                                <div class="card_texts">{{item.bidSectionName}}</div>
                            </el-tooltip>
                        </div>
                    <div class="card_cont">
                        <span><icon-svg name="w"></icon-svg></span>
                        <span class="card_cont_span">预警内容</span>
                        <el-tooltip class="tooltipItem" effect="dark" :content="item.warnContent" placement="right">
                            <div>{{item.warnContent}}</div>
                        </el-tooltip>
                        &nbsp;:&nbsp;{{item.actualValue}}
                    </div>
                    <div class="card_cont">
                        <span><icon-svg name="rt"></icon-svg></span>
                        <span class="card_cont_span">预警条件</span>
                        {{item.warnCondition}}
                    </div>
                    <div class="card_cont">
                        <span><icon-svg name="time"></icon-svg></span>
                        <span class="card_cont_span">预警时间</span>
                        {{item.warnTime}}
                    </div>
                </div>
                <div v-if="!item.code" class="card-btn">
                    <el-button type="primary" size="mini" @click="openDetail(item.id)">查看</el-button>
                    <el-button type="text" size="mini" v-if="item.historyid==-1" @click="dealDetail(item)">忽略</el-button>
                </div>
            </el-card>
        </el-col>
         <template v-if="page.total-Number(list.length)>0">
            <el-col :span="6">
                <div class="more" @click="moreData">
                    <span>
                        {{page.total>=Number(list.length)+7?'加载更多':`加载剩余 ${page.total-Number(list.length)} 条`}}
                        <img src="@/assets/images/right_circle.png" alt="">
                    </span>
                </div>
            </el-col>
        </template>
        <el-dialog title="处理意见" :visible.sync="dialogVisible" width="30%">
            <div class="dialogBox">
                <el-input type="textarea" maxlength="200"  show-word-limit v-model="auditForm.opinion"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handle()"  style="margin-bottom:20px;">确 定</el-button>
                <el-button @click="dialogVisible=false" class="backBtn">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {jzwarnrecordHandle } from "@/server/warnItem";
export default {
    props:{
        type:{
            type:Object,
            default:''
        },
        list:{
            type:Array,
            required:true
        },
        page:{
            type:Object,
            required:true
        }
    },
    data(){
        return{
            dialogVisible:false,
            auditForm:{
                opinion:'',
                historyId:1
            },
            dealId:''
        }
    },
    methods:{
        openDetail(id){//查看详情
            this.$emit('jumpData',id)
        },
        dealDetail(row){//处理
            this.dealId=row.id;
            this.dialogVisible=true;
        },
        moreData(){//查看更多
            this.$emit('moreData',{type:this.type.type,page:this.list.length});
        },
        handle() {//处理数据
            if (this.auditForm.opinion == '') {
                this.$message({
                message: '请填写处理意见',
                type: 'warning'
                });
                return;
            }
            jzwarnrecordHandle({id:this.dealId,opinion:this.auditForm.opinion,historyId:this.auditForm.historyId}).then(({data}) => {
                if (data.code == '1') {
                this.dialogVisible = false;
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.$emit('refreshData', true);
                } else {
                this.$message({
                    message: '操作失败',
                    type: 'warning'
                });
                }
            })
            },
        },
    created(){
        
    }
}
</script>

<style lang="scss" scoped>
  .projectCard{
      position: relative;
      height: 191px;
      box-shadow: 0px 0px 8px 0px rgba(72, 92, 109, 0.2);
      border-radius: 4px;
      overflow: hidden;
    /deep/ .el-card__body{
      padding: 0;
      height: 145px;
    }
    /deep/ .el-card__header{
      padding: 0px;
    //   min-height: 82px;
    }
    /deep/ .el-card__body{
        padding:12px 16px
    }
    .processStatus{
      top: 20px;
    }
    .card_title{
        color: #000000;
    }
    .header_img{
        position: absolute;
        top: 70px;
        right: 12px;
    }
    .header_img1{
        position: absolute;
        bottom: -7px;
        right: -4px;
    }
    .card_text{
        font-weight: bold;
        width: 260px;
        height: 24px;
        color: #000000;
        line-height: 20px;
        display: block;
        .card_texts{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        // display: -webkit-box;
        // -webkit-line-clamp: 2;
        // line-clamp: 2;
        // -webkit-box-orient: vertical
    }
    .card_cont{
        color: #486D8F;
        font-size: 12px;
        line-height: 24px;
        overflow: hidden;
        text-overflow:ellipsis; 
        white-space: nowrap;
        align-items: center;
        display: flex;
        &>span:nth-of-type(1){
            width:14px ;
            height: 21px;
            display: inline-block;
            .icon-svg{
                margin-top: 3px;
            }
        }
        .card_cont_span{
            color: rgba(0, 0, 0, 0.45);
            padding-right:16px;
            display: inline-block;
            line-height: 24px;
        }
    }
    .tooltipItem{
        display: inline-block;
        overflow: hidden;
        text-overflow:ellipsis; 
        white-space: nowrap;
        max-width: calc(100% - 70px);
    }
  }
.is-danger{
    background: #FEF0F0;
    
    
    /deep/.el-card__header{
        background: rgba(242, 48, 48, 0.1)
    }
}
.is-warning{
    /deep/.el-card__header{
    background: rgba(255, 153, 0, 0.1)
    }
}
.is-default{
    /deep/.el-card__header{
    background: rgba(255, 197, 0, 0.1)
    }
}
.card-btn{
    position: absolute;
    bottom: 8px;
    right:calc(50% - 51px);
    /deep/ .el-button--primary{
        background: linear-gradient(90deg, #35C3FF 0%, #1890FF 100%);
        border:none;     
        padding:6px 24px
    }
}
.more{
    height: 191px;
    line-height: 191px;
    background: #F5F7FB;
    border: 1px solid #F4F6FA;
    color: #1890FF;
    font-size: 18px;
    text-align: center;
    cursor: pointer;
}
</style>